
/**
 * @ngdoc directive
 * @name partners
 *
 * @description
 * Partners
 */
module.directive('partners', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '='
        },
        template:
                '<div class="aqua-partners">' +
                '  <div class="grid-main aqua-partners--container">' +
                '    <img ng-repeat="partner in content" aqua-src="{{partner.src}}" alt="{{partner.alt}}" />' +
                '  </div>' +
                '</div>'
    };
});
